import React, { useState, useEffect } from 'react';
import language from '../language';

const UserManagement = ({ users, addUser, updateUserSports }) => {
    const [newUserName, setNewUserName] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedSports, setSelectedSports] = useState([]);

    const handleAddUser = () => {
        if (newUserName) {
            addUser(newUserName);
            setNewUserName('');
        }
    };

    const handleUpdateUserSports = () => {
        if (selectedUser) {
            updateUserSports(selectedUser, selectedSports);
        }
    };

    // Update selectedSports when a user is selected
    useEffect(() => {
        if (selectedUser) {
            const user = users.find((user) => user.name === selectedUser);
            setSelectedSports(user ? user.sports : []);
        } else {
            setSelectedSports([]);
        }
    }, [selectedUser, users]);

    return (
        <div className="user-management">
            <h2>{language.userManagement}</h2>
            <div>
                <input
                    type="text"
                    value={newUserName}
                    onChange={(e) => setNewUserName(e.target.value)}
                    placeholder={language.enterUserName}
                />
                <button onClick={handleAddUser}>{language.addUser}</button>
            </div>
            <div>
                <h3>{language.selectUser}</h3>
                <select
                    onChange={(e) => setSelectedUser(e.target.value)}
                    value={selectedUser || ''}
                >
                    <option value="">{language.selectUser}</option>
                    {users.map((user) => (
                        <option key={user.name} value={user.name}>
                            {user.name}
                        </option>
                    ))}
                </select>
            </div>
            {selectedUser && (
                <div>
                    <h3>{language.configureSports}</h3>
                    <label>
                        <input
                            type="checkbox"
                            value="handball"
                            checked={selectedSports.includes('handball')}
                            onChange={(e) => {
                                const sport = e.target.value;
                                setSelectedSports((prev) =>
                                    prev.includes(sport)
                                        ? prev.filter((s) => s !== sport)
                                        : [...prev, sport]
                                );
                            }}
                        />
                        {language.handball}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="soccer"
                            checked={selectedSports.includes('soccer')}
                            onChange={(e) => {
                                const sport = e.target.value;
                                setSelectedSports((prev) =>
                                    prev.includes(sport)
                                        ? prev.filter((s) => s !== sport)
                                        : [...prev, sport]
                                );
                            }}
                        />
                        {language.soccer}
                    </label>
                    <button onClick={handleUpdateUserSports}>{language.updateSports}</button>
                </div>
            )}
        </div>
    );
};

export default UserManagement;